import {ChangeDetectionStrategy, Component} from '@angular/core';
import {NavController, NavParams, ViewController} from 'ionic-angular';
import {TGoogleAnalytic, TStatusBar, Util} from "../../../app/util";
import {CONFIG} from "../../../app/config";
import {TAction} from "../../../app/enum";

import {DataService} from "../../../providers/data-service";
import {LogadoService} from "../../../providers/logado-service";
import {ProfileService} from '../../../providers/profile-service';

import {ListingMenuPage} from "../listing-menu/listing-menu";
import {WebstorService} from "../../../providers/webstor-service";

@Component({
    selector: 'page-account-menu',
    templateUrl: 'account-menu.html',
    providers: [ProfileService, WebstorService],
    changeDetection: ChangeDetectionStrategy.Default
})
export class AccountMenuPage {

    config: any;
    logado: any;

    etapa: number;
    indexAC: number;
    rootile: any;
    copyile: any;

    constructor(public navCtrl: NavController, public navParams: NavParams,
                public util: Util, public logadoService: LogadoService,
                public viewCtrl: ViewController, public dataService: DataService,
                public profileService: ProfileService,
                public webstorService: WebstorService) {

        this.config = CONFIG;
        this.logado = this.logadoService.getAuth();

        this.etapa = this.navParams.get('etapa');
        this.indexAC = this.navParams.get('indexAC');
        this.rootile = this.navParams.get('rootile');
        this.copyile = this.util.deepCopy(this.rootile);

        this.prepareLoad();

    }

    ionViewDidEnter() {

        this.util.statusBarColor(TStatusBar.sbStyleDefault);

    }

    getTitle() {

        return 'Conta Corrente';

    }

    prepareLoad() {

        /* Google Analytics */
        if (this.etapa == 0) this.util.googleAnalytic(TGoogleAnalytic.gaPageview, 'Account', '/account-list');
        if (this.etapa == 1) this.util.googleAnalytic(TGoogleAnalytic.gaPageview, 'Account', '/account-info');

        //Account New
        if (!this.copyile.Accounts.length) {
            let account = {AccountID: 0, AccountNoag: '', AccountNocc: '', Branded: null};
            this.copyile.Accounts.push(account);
        }

    }

    accountErro(alert): boolean {

        // Field Force
        let vazio = '';

        // etapa = 2 Endereço
        let account = this.copyile.Accounts[this.indexAC];
        if (!vazio && !this.util.jsTrim(account, ['Branded']))     vazio = 'Seu Banco';
        if (!vazio && !this.util.jsTrim(account, ['AccountNoag'])) vazio = 'Sua agência';
        if (!vazio && !this.util.jsTrim(account, ['AccountNocc'])) vazio = 'Sua conta';

        // Field verify
        if (vazio && alert) this.util.alertSimply(vazio, 'Obrigatório Informar');

        return !!vazio;

    }

    accountSave(acLixo: boolean = false) {

        if (this.accountErro(true)) return;

        let account = this.copyile.Accounts[this.indexAC];

        let onSave = (codigo) => {
            if (codigo) account.AccountID = codigo;
            if (acLixo) {
                this.copyile.Accounts.splice(this.indexAC, 1);
                this.rootile.Accounts.splice(this.indexAC, 1);
            }
            this.util.populateObj(this.rootile, this.copyile);
            this.dismiss();
        };

        let loading = this.util.loadingDots();
        loading.present();

        let action = (acLixo ? TAction.acLixo : TAction.acSave);
        this.profileService.account(action, account.AccountID, this.copyile.Profile.ProfileID, 0, account)
            .finally(() => loading.dismiss())
            .subscribe(
                data => onSave(data.Codigo),
                erro => this.util.alertPopula(erro, this.rootile, this.copyile)
            );

    }

    brandedBank() {

        let alignL = {type: 'logo', text: '', show: 'BrandedLogo', info: '', color: ''};
        let alignC = {type: 'text', text: '', show: 'BrandedNome', info: '', color: ''};
        let alignR = {type: 'none', show: '', info: '', color: ''};

        let onShow = (show, that, limitPage, reload) => {

            let loading = this.util.loadingDots();
            loading.present();

            this.webstorService.branded(TAction.acBank)
                .finally(() => loading.dismiss())
                .subscribe(
                    data => that.parseArray(data.Brandeds),
                    erro => this.util.alertResult(erro, () => that.dismiss())
                );

        };

        let onOkuy = (okey, that, line, click, event) => {
            this.copyile.Accounts[this.indexAC].Branded = line;
            that.dismiss();
        };

        let modalshow = this.config.listingForm('Banco', onShow, onOkuy, alignL, alignC, alignR);
        let objectData = {profile: this.logado.Profile, modalshow: modalshow};

        this.util.modalopen(ListingMenuPage, 'alto', false, objectData).subscribe();

    }

    dismiss() {

        let account = this.copyile.Accounts[this.indexAC];
        let accountNovo = !account.AccountID;
        let accountLixo = this.accountErro(true);
        let profileNovo = !this.copyile.Profile.ProfileID;

        if (profileNovo && !accountLixo) {
            this.util.populateObj(this.rootile, this.copyile);
        }

        if (accountNovo && (!profileNovo || accountLixo)) {
            this.copyile.Accounts.splice(this.indexAC, 1);
            this.rootile.Accounts.splice(this.indexAC, 1);
            this.util.populateObj(this.copyile, this.rootile);
        }

        if (this.viewCtrl.isOverlay) this.viewCtrl.dismiss();
        else this.navCtrl.pop();

    }

}



// WEBPACK FOOTER //
// ./src/pages/sync/account-menu/account-menu.ts